import script from "./Withdraw.vue?vue&type=script&setup=true&lang=js"
export * from "./Withdraw.vue?vue&type=script&setup=true&lang=js"

import "./Withdraw.vue?vue&type=style&index=0&id=3f15d858&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f15d858"]])

export default __exports__